import { Dispatch } from 'redux'
import { clearRegisterPrescriptionResult } from 'core/modules/registerPrescriptionResult'

export function callClearRegisterPrescriptionResult() {
  return async (dispatch: Dispatch) => {
    dispatch(clearRegisterPrescriptionResult())
  }
}
